import { render, staticRenderFns } from "./FormularioCtrlRegionaisComponent.vue?vue&type=template&id=8795cd9a"
import script from "./FormularioCtrlRegionaisComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlRegionaisComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports